module.exports = __webpack_public_path__ + "img/AVI.4b9e8e66.png";